<template>
  <div class="system">
    <div class="system-header-top">
      <v-btn icon
             color="primary"
             class="margin-right-small"
             @click="onBackClick"
      >
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
      <h1>System</h1>
    </div>

    <div class="system-form">
      <div class="system-header">
        <h2>Local media</h2>
      </div>

      <v-data-table
        v-if = "loadedMedia"
        :items="loadedMedia"
        :headers="localMediaHeaders"
      >
        <template v-slot:item.device="{ item }">
          <div v-if = "item.device == 0">CPU</div>
          <div v-if = "item.device >= 128">GPU {{ item.device - 127 }}</div>
        </template>
        <template v-slot:item.growing="{ item }">
          <div v-if="item.open">YES</div>
          <div v-else>NO</div>
        </template>
        <template v-slot:item.unload="{ item }">
          <div v-if = "item.unload !== undefined">
            <v-btn :disabled="item.unload"
                   color="primary"
                   @click="unload(item)"
                   width="100px"
            >
              <div>Unload</div>
            </v-btn>
          </div>
        </template>
        <template v-slot:item.statistics="{ item }">
          <div>
            Cache: {{ item.statistics.cache }}
          </div>
        </template>
      </v-data-table>
    </div>

    <div class="system-form">
      <div class="system-header">
        <h2>Remote media</h2>
      </div>

      <div v-for="i in remoteHosts"
           :key="i.Host"
      >
        <h3>{{ i.host }}</h3>
        <v-data-table
          v-if = "i.remoteMedia"
          :items="i.remoteMedia"
          :headers="remoteMediaHeaders"
        >
          <template v-slot:item.growing="{ item }">
            <div v-if="item.open">YES</div>
            <div v-else>NO</div>
          </template>
          <template v-slot:item.device="{ item }">
            <div v-if = "item.device == 0">CPU</div>
            <div v-if = "item.device >= 128">GPU {{ item.device - 127 }}</div>
          </template>
        </v-data-table>
      </div>
    </div>

    <v-snackbar
      v-model="redSnackbar.isVisible"
      :timeout="redSnackbar.timeout"
      color="red"
    >
      {{ redSnackbar.text }}
      <v-btn
        text
        @click="redSnackbar.isVisible = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <v-snackbar
      v-model="greenSnackbar.isVisible"
      :timeout="greenSnackbar.timeout"
      color="green"
    >
      {{ greenSnackbar.text }}
      <v-btn
        text
        @click="greenSnackbar.isVisible = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <ConfirmationDialog ref="confirmation_dialog"></ConfirmationDialog>
  </div>
</template>

<script>
import {ConnectionService} from "../services/connection.service";
import ConfirmationDialog from '../components/panes/components/dialogs/ConfirmationDialog';

export default {
  name: "System",

  components: {
    ConfirmationDialog
  },
  data() {
    return {
      connection:        null,
      greenSnackbar:     { isVisible: false, timeout: 0, text: "" },
      redSnackbar:       { isVisible: false, timeout: 0, text: "" },
      loadedMedia:       [],
      remoteHosts:       [],
      localMediaHeaders: [
        {
          text:     'Path',
          align:    'start',
          sortable: false,
          value:    'path',
        },
        { text: 'Open', value: 'growing' },
        { text: 'Device', value: 'device' },
        { text: 'Commands', value: 'unload' },
        { text: 'Statistics', value: 'statistics' },
      ],
      remoteMediaHeaders: [
        {
          text:     'Path',
          align:    'start',
          sortable: false,
          value:    'path',
        },
        { text: 'Open', value: 'growing' },
        { text: 'Device', value: 'device' },
      ],
    };
  },
  async mounted() {
    this.connection = ConnectionService.getAutoReconnectConnection("/manager");
    this.initHandler();
    await this.connection.start();
  },
  async beforeDestroy() {
    await this.connection?.stop();
  },
  methods: {
    onBackClick() {
      this.$router.push('/')
    },
    initHandler() {
      this.connection.on('AddMedia', (response) => {
        this.handleAddMedia(response);
      });
      this.connection.on('RemoveMedia', (response, open) => {
        this.handleRemoveMedia(response, open);
      });
      this.connection.on('AddRemoteMedia', (host, response) => {
        this.handleAddRemoteMedia(host, response);
      });
      this.connection.on('RemoveRemoteMedia', (host, response, open) => {
        this.handleRemoveRemoteMedia(host, response, open);
      });
      this.connection.on('Connect', (host) => {
        this.handleConnect(host);
      });
      this.connection.on('Disconnect', (host) => {
        this.handleDisconnect(host);
      });
      this.connection.on('UpdateStatistics', (response) => {
        this.handleUpdateStatistics(response);
      });
    },
    handleUpdateStatistics(response) {
      for (var media of this.loadedMedia)
      {
        if (media.path == response.path) {
          media.statistics = response.statistics
        }
      }
    },
    handleAddMedia(response) {
      response.unload = false;
      this.loadedMedia.push(response);
    },
    handleRemoveMedia(response, open) {
      this.loadedMedia = this.loadedMedia.filter(media => media.path != response && media.open != open);
    },
    handleAddRemoteMedia(host, response) {
      for (var remoteHost of this.remoteHosts)
      {
        if (remoteHost.host == host)
        {
          remoteHost.remoteMedia.push(response);

          break;
        }
      }
    },
    handleRemoveRemoteMedia(host, response, open) {
      for (var remoteHost of this.remoteHosts)
      {
        if (remoteHost.host == host)
        {
          remoteHost.remoteMedia = remoteHost.remoteMedia.filter(media => media.path != response && media.open != open);

          break;
        }
      }
    },
    handleConnect(response) {
      this.remoteHosts.push({"host": response, "remoteMedia": []});
    },
    handleDisconnect(response) {
      this.remoteHosts = this.remoteMedia.filter(media => media.host != response);
    },
    showFailure(reason, timeout = 60000) {
      if(Array.isArray(reason)) {
        reason = reason.join('\n');
      }

      this.redSnackbar.timeout = timeout;
      this.redSnackbar.text = reason;
      this.redSnackbar.isVisible = true;
    },
    showSuccess(reason, timeout = 5000) {
      this.greenSnackbar.timeout = timeout;
      this.greenSnackbar.text = reason;
      this.greenSnackbar.isVisible = true;
    },
    async unload(item) {
      if (await this.connection.invoke('IsFileInUseByOthers', item.path)) {
        if (await this.$refs.confirmation_dialog.confirm(
          'Unload video?',
          'Another user is using this file. Are you sure you want to unload this video?',
          'Unload Video',
          'error',
          'Keep Video',
          'primary'
        )) {
          this.connection.invoke("Unload", item.path, item.open);
          item.unload = true;
        }
      }
      else {
        this.connection.invoke("Unload", item.path, item.open);
        item.unload = true;
      }

    }
  }
}
</script>

<style>
    .system {
        padding-top: 20px;
    }

    .system-header-top {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .system-form {
        margin-left: 10px;
        padding-top: 30px;
        width: 80%;
    }

    .system-form > {
        padding-top: 20px;
    }

    .system-header {
        padding-bottom: 10px;
    }

</style>
